<template>
  <div class="report-reason">
    <img v-bind:src="$setPicSize(pic)" width="100%" alt="加载中..." />
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'

export default {
  name: 'uploadExample',
  data() {
    return {
      pic: 'ffbe2a9d-7d5f-44e9-a9b2-292b4fb76fb8.png'
    }
  },
  computed: {},
  methods: {
    $setPicSize(url) {
      return setPicSize(url)
    },
    closePage() {
      native.close()
    }
  },
  mounted() {
    native.setTitle({
      title: '防骗指南'
    })
  },
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style scoped lang="less">
  @import 'PreventFoolExample.less';
</style>
